// Niveles educativos centralizados — única fuente de verdad para todo el CRM.
// Fuente original: lead-unified-view.jsx (incluye color/bg para badges).
// Los consumidores que solo necesitan value/label pueden ignorar color/bg.

export const NIVEL_OPTIONS = [
  { value: "maternal", label: "Maternal", color: "#f59e0b", bg: "rgba(245,158,11,0.12)" },
  { value: "kinder", label: "Kinder", color: "#f59e0b", bg: "rgba(245,158,11,0.12)" },
  { value: "prefirst", label: "Pre-First", color: "#f59e0b", bg: "rgba(245,158,11,0.12)" },
  { value: "primaria", label: "Primaria", color: "#22c55e", bg: "rgba(34,197,94,0.12)" },
  { value: "secundaria", label: "Secundaria", color: "#0ea5e9", bg: "rgba(14,165,233,0.12)" },
  { value: "preparatoria", label: "Preparatoria", color: "#a855f7", bg: "rgba(168,85,247,0.12)" },
]

// Mapa clave -> etiqueta (claves en minúsculas, como vienen de la BD)
export const NIVEL_LABELS = Object.fromEntries(
  NIVEL_OPTIONS.map((o) => [o.value, o.label])
)

// Lookup case-insensitive con fallback al valor crudo
export const getNivelLabel = (value) => {
  if (!value) return value ?? ""
  const opt = NIVEL_OPTIONS.find((o) => o.value === String(value).toLowerCase())
  return opt ? opt.label : value
}
